module.exports = __webpack_public_path__ + "img/mantraz-logo-horizontal.650d497d.svg";